import { writable } from '../external_node_modules/svelte/store/index.mjs.js';
import preparePurchaseByPlatform from '../api/fetchInfo.js';
import { EVENTS } from '../constants/events.js';
import events from '../core/event/index.js';

const currentProduct = null;
const { subscribe, update } = writable(currentProduct);
function changeCurrentProduct(product, storefrontName) {
    return update((state) => {
        state = product;
        events.emit(EVENTS.CHANGE_CURRENT_PRODUCT, { currentProductId: state.id });
        preparePurchaseByPlatform(state, storefrontName);
        return state;
    });
}
var currentProduct$1 = {
    subscribe,
};

export { changeCurrentProduct, currentProduct$1 as default };
//# sourceMappingURL=currentProduct.js.map
